import React from "react"

import Item from "./items/item"
import { List, Title, Items } from "./styles"

const ProductReviewQuickList = ({ article, element }) => {
  const { reviewProducts } = article
  const { anchor, title, productReviews } = element

  const findProduct = (productId) => reviewProducts.find(({ id }) => id === productId)

  return (
    <List id={`mbg-${anchor}`} className="experiment-product-review-quick-list-A">
      <Title>{title}</Title>
      <Items>
        {productReviews.map((productReview) => (
          <Item
            key={`product-review-quick-list-item-${productReview.productId}`}
            anchor={productReview.anchor}
            category={productReview.category}
            product={findProduct(productReview.productId)}
          />
        ))}
      </Items>
    </List>
  )
}

export default ProductReviewQuickList
